import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Link,
  List,
  ListItem,
  Popover,
  PopoverOrigin,
  Typography,
} from "@material-ui/core";
import { useStyles } from "../styles";

interface Props {
  items: string[];
  total: number;
  actionLabel: string;
}

export default function DataItemsPopover(props: Props) {
  const { total, items, actionLabel } = props;
  const { t } = useTranslation("emailFlowLogs");
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const [anchor, setAnchor] = useState(null);
  const anchorProps: PopoverOrigin = { vertical: "bottom", horizontal: "left" };
  const transformProps: PopoverOrigin = { vertical: "top", horizontal: "left" };

  const onOpen = e => {
    setIsOpen(true);
    setAnchor(e.currentTarget);
  };

  const onClose = e => {
    setIsOpen(false);
    setAnchor(null);
  };

  return (
    <>
      {!Boolean(total) && (
        <Typography className={classes.dataItem}>{t("common:no")}</Typography>
      )}

      {total === 1 && (
        <Typography className={classes.dataItem}>{items[0]}</Typography>
      )}

      {total > 1 && (
        <>
          <Link
            color="primary"
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={onOpen}
          >
            {actionLabel}
          </Link>
          <Popover
            open={isOpen}
            anchorEl={anchor}
            onClose={onClose}
            anchorOrigin={anchorProps}
            transformOrigin={transformProps}
            classes={{ paper: classes.dataItemPopoverPaper }}
          >
            {items.map(file => (
              <List style={{ padding: 0 }}>
                <ListItem>
                  <Typography className={classes.dataItem}>{file}</Typography>
                </ListItem>
              </List>
            ))}
          </Popover>
        </>
      )}
    </>
  );
}
